"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing_1 = require("../spacing");
class ItemPositioner {
    constructor(line) {
        this.line = line;
    }
    get _layout() {
        return this.line.getLayout();
    }
    position() {
        const { spacingBefore, spacingBetween } = this.getSpacing();
        let currentPos = spacingBefore;
        const items = this.line.items;
        for (let i = this.line.startIndex; i <= this.line.endIndex; i++) {
            const item = items[i];
            item.flexItem.setMainAxisLayoutPos(currentPos);
            currentPos += item.flexItem.getMainAxisLayoutSizeWithPaddingAndMargin();
            currentPos += spacingBetween;
        }
    }
    getSpacing() {
        const remainingSpace = this.line.availableSpace;
        const mode = this._layout.container.justifyContent;
        const numberOfItems = this.line.numberOfItems;
        return spacing_1.getSpacing(mode, numberOfItems, remainingSpace);
    }
}
exports.ItemPositioner = ItemPositioner;
//# sourceMappingURL=ItemPositioner.js.map